import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import "./style.scss";
import config from "./../../utils/const";

const ButtomClose = () => (
  <a href={config.urlAbs}>
    <FontAwesomeIcon icon={faTimes} className="buttom-close" />
  </a>
);

export default ButtomClose;
